import { AbstractBlock } from '../AbstractBlock';
import { ShapeSettings } from '../setting/ShapeSettings';
import { ColorSettings } from '../setting/ColorSettings';
import { CodeSetting } from '../setting/CodeSetting';
import { BlockType } from '../../@types/BlockType';
import { block_translation } from '../../lang/BlockTranslation';
const t = block_translation;

export class ColorAttribute extends AbstractBlock {
  constructor() {
    super('color_att_v2', t.to('色', 'color'));
    this.setNameForCode('color');
  }

  /**
   * @override AbstractBlock
   * @param {} dom
   */
  toXmlFromSubBlockCustom(dom: HTMLElement): void {
    dom.appendChild(ShapeSettings.getColorInputValueXML());
  }

  defineBlock(block: BlockType): void {
    ShapeSettings.setAttributeShape(block);
    ColorSettings.setAttributeColor(block);

    ShapeSettings.setTitleField(block, this.title);
    ShapeSettings.addColorInput(block);
    ShapeSettings.addAttributeInput(block);
  }

  /**
   * Override
   * @param {} block
   */
  codeGenerateCore(block: BlockType): string[] {
    const colorValue = CodeSetting.getColorInputValue(block);
    const attribute = CodeSetting.getSubAttributeCode(block);
    // let str = " " + self.name_for_code + " = '" + colorValue + "' "  + attribute ;
    const str = CodeSetting.buildAttribute([[this.name_for_code, colorValue]], attribute);
    return [str];
  }
}
